import { getVisibleFieldError, useField } from '@ff-it/form';
import { Alert } from '@ff-it/ui';
import { ReactElement } from 'react';

const subscription = {
  submitError: true,
  dirtySinceLastSubmit: true,
  error: true,
  dirty: true,
  touched: true,
};
function errorMessages(error: unknown): string[] {
  if (typeof error === 'string') return [error];
  if (Array.isArray(error) && error.every((message) => typeof message === 'string')) return error;
  if (error && typeof error === 'object' && 'non_field_errors' in error) {
    return errorMessages((error as { non_field_errors?: unknown }).non_field_errors);
  }
  return [];
}

export function FormInlineError({ name, className }: { name: string; className?: string }): ReactElement | null {
  const { meta } = useField(name, { subscription });
  const messages = errorMessages(getVisibleFieldError(meta));

  if (!messages.length) return null;
  return (
    <Alert variant="danger" className={className} mb="3">
      {messages.map((message) => (
        <div key={message}>{message}</div>
      ))}
    </Alert>
  );
}
/**
 * @deprecated do we ever want this? We don't have a place to render this in table
 * ! We DO want this having error on particular member is helpful
 * */
export function FormInlineMemberError({ name, className }: { name: string; className?: string }): ReactElement | null {
  return <FormInlineError name={name} className={className} />;
}
